import { useRouter } from "next/router";
import { useRuntime } from "./useRuntime";
export var useHost = function() {
    var ref;
    var ref1 = useRuntime(), _host = ref1.host, hostName = _host.hostName, imageHost = _host.imageHost, locale = ref1.locale;
    var router = useRouter();
    var localeString = "";
    if (router === null || router === void 0 ? void 0 : (ref = router.locales) === null || ref === void 0 ? void 0 : ref.map(function(l) {
        return l.toLowerCase();
    }).includes(locale.toLowerCase())) {
        localeString = "/".concat(locale.toLowerCase());
    }
    var cleanHostName = hostName// remove subdomains
    .replace(/^[^.]+\./g, "")// remove port
    .replace(/:\d+$/, "");
    var cookieDomain = // @see https://stackoverflow.com/a/1188145
    cleanHostName === "localhost" ? undefined : cleanHostName;
    /**
   * @todo: Align with the BM/CG host context, driven by the same
   * settings-based approach
   * */ return {
        baseUrl: "https://".concat(hostName),
        baseLocalizedUrl: "https://".concat(hostName).concat(localeString),
        baseImageUrl: "https://".concat(imageHost),
        hostName: hostName,
        cookieDomain: cookieDomain
    };
};
